export default "__VITE_ASSET__T_gf4nLn0sJZYexQSVPmng__"